import React from "react";
import Box from "@mui/material/Box";
import constants from "../../../../../../config/constants";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

// Props: specialCases: Array<{ name: string, description: string, color: string }>
// onBack: () => void
const SpecialCases = ({specialCases = [], onBack, gameId}) => {

    const baseImageUrl = constants.api.basePath + "/generated/" + gameId + "/image";

    return (
        <Box sx={{width: "100%", gap: 2, marginBottom: "120px"}}>
            {/* Back control consistent with GameRules */}
            <button
                aria-label="Retour"
                onClick={onBack}
                style={{
                    alignSelf: "flex-start",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                    background: "transparent",
                    color: "#fff",
                    border: "none",
                    fontSize: 16,
                    fontWeight: 600,
                    cursor: "pointer",
                    padding: 8,
                    borderRadius: 8,
                }}
            >
                <ArrowBackIosNewIcon fontSize="small" />
                Retour
            </button>

            {/* Special cases list */}
            <div style={{display: "flex", flexDirection: "column"}}>
                {specialCases.map((sc) => {
                    const imageSrc = `${baseImageUrl}?imagePath=special_cases/special_case_${encodeURIComponent(sc.name.toLowerCase())}.png`
                    return (
                        <div key={sc.name} style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "stretch",
                            background: "linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.03))",
                            borderRadius: 12,
                            margin: "8px 0",
                            overflow: "hidden"
                        }}>
                            <div style={{
                                width: "25%",
                                minWidth: 120,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: 12,
                                boxSizing: "border-box",
                                background: sc.color || "transparent"
                            }}>
                                <img
                                    src={imageSrc}
                                    alt={sc.name}
                                    style={{width: "100%", height: "auto", objectFit: "contain"}}
                                />
                                <div style={{
                                    marginTop: 8,
                                    color: "#fff",
                                    fontWeight: 600,
                                    textAlign: "center"
                                }}>
                                    {sc.name}
                                </div>
                            </div>

                            <div style={{flex: 1, padding: 12, color: "#fff"}}>
                                {/* Remove leading indentation but preserve line breaks */}
                                <div style={{whiteSpace: "pre-wrap"}}>{(sc.description ?? "").trimStart()}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </Box>
    );
};

export default SpecialCases;
